import useAuthentication from 'hooks/common/useAuthentication';

const useHomePath = (): string => {
  const { isLoggedIn } = useAuthentication();
  return isLoggedIn ? '/announcements' : '/login';
};

export default useHomePath;
